import React from 'react';
import { StyledHeader } from './component';

export const StyledHeaderContainer = (props) => {
  const { title, onClose } = props;
  return <StyledHeader title={title} onClose={onClose} />;
};
